/**
 * Localize Klaviyo Back-in-Stock trigger + popup (form Rfw3Vp).
 * Klaviyo injects English after page load, so this runs on product pages
 * and reapplies copy when the app re-renders the DOM.
 */
(function () {
  'use strict';

  var EN = {
    trigger: 'Notify me when back in stock',
    triggerAlt: 'Notify Me When Back in Stock',
    title: "Be the First to Know When It's Back.",
    subtitle: "Enter your email and we'll let you know the moment this item is back.",
    placeholder: 'Enter your email address',
    checkbox: 'also receive promotional marketing emails.',
    submit: 'Notify Me!',
    close: 'Close dialog',
    emailLabel: 'Email',
    successTitle: "You're all set!",
    successSubtitle: 'Keep an eye out for a back-in-stock message.'
  };

  var STRINGS = {
    de: {
      trigger: 'Benachrichtigen, wenn wieder verfügbar',
      title: 'Erfahren Sie als Erste, wenn der Artikel wieder da ist.',
      subtitle:
        'Geben Sie Ihre E-Mail-Adresse ein, und wir benachrichtigen Sie, sobald der Artikel wieder verfügbar ist.',
      placeholder: 'Geben Sie Ihre E-Mail-Adresse ein',
      checkbox: 'auch Werbe-E-Mails erhalten.',
      submit: 'Benachrichtigen!',
      close: 'Dialog schließen',
      emailLabel: 'E-Mail',
      successTitle: 'Alles klar!',
      successSubtitle: 'Achten Sie auf eine Nachricht, sobald der Artikel wieder verfügbar ist.'
    },
    fr: {
      trigger: 'Me prévenir du retour en stock',
      title: 'Soyez les premiers informés du retour en stock.',
      subtitle:
        'Saisissez votre e-mail et nous vous préviendrons dès que cet article sera de nouveau disponible.',
      placeholder: 'Saisissez votre adresse e-mail',
      checkbox: 'recevoir également des e-mails promotionnels.',
      submit: 'Prévenez-moi !',
      close: 'Fermer la fenêtre',
      emailLabel: 'E-mail',
      successTitle: "C'est tout bon !",
      successSubtitle: 'Surveillez votre boîte mail : nous vous préviendrons du retour en stock.'
    },
    es: {
      trigger: 'Avisarme cuando vuelva a estar disponible',
      title: 'Sé el primero en saber cuándo vuelve.',
      subtitle: 'Introduce tu correo y te avisaremos en cuanto este artículo vuelva a estar disponible.',
      placeholder: 'Introduce tu correo electrónico',
      checkbox: 'también recibir emails promocionales.',
      submit: '¡Avísame!',
      close: 'Cerrar el cuadro de diálogo',
      emailLabel: 'Correo electrónico',
      successTitle: '¡Listo!',
      successSubtitle: 'Estate atento: te avisaremos cuando vuelva a estar disponible.'
    },
    it: {
      trigger: 'Avvisami quando torna disponibile',
      title: 'Scopri per primo quando torna disponibile.',
      subtitle: 'Inserisci la tua email e ti avviseremo non appena l’articolo sarà di nuovo disponibile.',
      placeholder: 'Inserisci il tuo indirizzo email',
      checkbox: 'ricevere anche email promozionali.',
      submit: 'Avvisami!',
      close: 'Chiudi la finestra',
      emailLabel: 'Email',
      successTitle: 'Tutto pronto!',
      successSubtitle: 'Tieni d’occhio la tua email: ti avviseremo quando torna disponibile.'
    }
  };

  function getLocale() {
    var raw =
      (window.Shopify && window.Shopify.locale) ||
      document.documentElement.lang ||
      'en';
    return String(raw).toLowerCase().slice(0, 2);
  }

  function normalize(value) {
    return String(value || '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function translationsFor(locale) {
    return STRINGS[locale] || null;
  }

  function collectKnown(key) {
    var values = [normalize(EN[key])];
    if (key === 'trigger') values.push(normalize(EN.triggerAlt));
    Object.keys(STRINGS).forEach(function (locale) {
      values.push(normalize(STRINGS[locale][key]));
    });
    return values;
  }

  function shouldReplace(current, key) {
    var known = collectKnown(key);
    return known.indexOf(normalize(current)) !== -1;
  }

  function setIfMatch(el, prop, key, next) {
    if (!el) return;
    var current = el[prop];
    if (!shouldReplace(current, key)) return;
    if (normalize(current) === normalize(next)) return;
    el[prop] = next;
  }

  function setTextIfMatch(el, key, next) {
    if (!el) return;
    if (!shouldReplace(el.textContent, key)) return;
    if (normalize(el.textContent) === normalize(next)) return;
    el.textContent = next;
  }

  function findTextNode(root, key) {
    if (!root) return null;
    var known = collectKnown(key);
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) {
      if (known.indexOf(normalize(node.textContent)) !== -1) return node;
    }
    return null;
  }

  function replaceTextNode(root, key, next) {
    var node = findTextNode(root, key);
    if (!node) return;
    if (normalize(node.textContent) === normalize(next)) return;
    node.textContent = next;
  }

  function localizeTrigger(t) {
    var container = document.getElementById('klaviyo-bis-button-container');
    if (!container) return;
    container.querySelectorAll('button').forEach(function (button) {
      setTextIfMatch(button, 'trigger', t.trigger);
    });
  }

  function findBisPopup() {
    var form = document.querySelector('[data-testid="klaviyo-form-Rfw3Vp"]');
    if (form) {
      return form.closest('[role="dialog"]') || form.closest('[data-testid="POPUP"]') || form;
    }

    var dialogs = document.querySelectorAll('[role="dialog"][data-kl-scroll-locking-modal], [data-testid="POPUP"]');
    var i;
    for (i = 0; i < dialogs.length; i += 1) {
      var text = normalize(dialogs[i].textContent);
      if (
        text.indexOf(normalize(EN.title)) !== -1 ||
        text.indexOf(normalize(EN.submit)) !== -1 ||
        text.indexOf(normalize(EN.successTitle)) !== -1 ||
        Object.keys(STRINGS).some(function (locale) {
          return (
            text.indexOf(normalize(STRINGS[locale].title)) !== -1 ||
            text.indexOf(normalize(STRINGS[locale].successTitle)) !== -1
          );
        })
      ) {
        return dialogs[i];
      }
    }
    return null;
  }

  function localizePopup(t) {
    var popup = findBisPopup();
    if (!popup) return;

    replaceTextNode(popup, 'title', t.title);
    replaceTextNode(popup, 'subtitle', t.subtitle);
    replaceTextNode(popup, 'checkbox', t.checkbox);
    replaceTextNode(popup, 'submit', t.submit);
    replaceTextNode(popup, 'successTitle', t.successTitle);
    replaceTextNode(popup, 'successSubtitle', t.successSubtitle);

    popup.querySelectorAll('input[type="email"]').forEach(function (input) {
      setIfMatch(input, 'placeholder', 'placeholder', t.placeholder);
    });

    popup.querySelectorAll('label[for]').forEach(function (label) {
      setTextIfMatch(label, 'emailLabel', t.emailLabel);
    });

    popup.querySelectorAll('.klaviyo-close-form, [aria-label]').forEach(function (el) {
      setIfMatch(el, 'ariaLabel', 'close', t.close);
    });

    popup.querySelectorAll('title').forEach(function (titleEl) {
      setTextIfMatch(titleEl, 'close', t.close);
    });
  }

  function localize() {
    var t = translationsFor(getLocale());
    if (!t) return;
    localizeTrigger(t);
    localizePopup(t);
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      localize();
    });
  }

  function start() {
    localize();
    var observer = new MutationObserver(schedule);
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
